import PropTypes from 'prop-types';
import styled from 'styled-components';

const ThemedLogoWrapper = styled.span`
    display: inline-flex;
`;

const LogoImage = styled.img`
    width: 100%;

    [data-theme="dark"] & {
        display: none;
    }
`;

const DarkLogoImage = styled(LogoImage)`
    display: none;

    [data-theme="dark"] & {
        display: block;
    }
`;

export default function ThemedLogo({ alt, className }) {
    return (
        <ThemedLogoWrapper className={className}>
            <LogoImage src="/assets/logo.svg" alt={alt} />
            <DarkLogoImage src="/assets/logo-inverted.svg" alt={alt} />
        </ThemedLogoWrapper>
    );
}

ThemedLogo.propTypes = {
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
};

ThemedLogo.defaultProps = {
    className: '',
};
